<script>
import VueRecaptcha from 'vue-recaptcha';
import Vue from 'vue'
import VeeValidate from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import VueSession from 'vue-session'
import 'whatwg-fetch'
import axios from 'axios'
import {config} from '../../config'


Vue.use(VueSession)

export default {
  name: 'question',
  data() {
    return {
      timeLimit:'00:00:10'
    }
  },
  props:['question','question-number'],
  methods:{

        submitAnswer:function(answerId=null) {
            this.$emit('answer', this.getAnswerObj(answerId));
            this.timeLimit = null;
            setTimeout(() => {
               this.timeLimit = '00:00:10';
            },300);
        },

        getAnswerObj(answerId){
          if(!answerId){
            return null;
          }
          let obj = {};
          obj['questionId'] = this.question.id;
          obj['answerId'] = answerId;
          return obj;
        },
        
        handleTimesUp(e){
           this.timeLimit = null;
           this.$emit('timesup', e);
           setTimeout(() => {
               this.timeLimit = '00:00:10';
           },300);
        },
        getQuestionPoints(catList){
           let points = catList.find((o, i) => {
            if (o.key=='point') {
              return o; 
            }
          });
          if(points){
            return points.value;
          }else{
            return '25';
          }
        },
        getQuestionTopic(catList){
           let topic = catList.find((o, i)=>{
             if (o.key=='topic') {
              return o; 
            }
           });
           if(topic){
               let catTopic = topic.value;
               if(catTopic=='Our national team'){
                   return 'images/jersey.png';
               }else if(catTopic=='Teams of the World'){
                   return 'images/football.png';
               }else if(catTopic=='Interesting facts'){
                   return 'images/history.png';
               }
           }else{
               return 'images/handHoldingTrophy.png';
           }
          
        }
  }
}
</script>



// WEBPACK FOOTER //
// src/quiz/question/Question.vue